<template>
    <li class="nav-item bg-success text-white pl-3 pr-3" style="font-size: 25px;" @click="modesmodel=true">
    <span v-if="data!=null">
        {{ convertHM(data.working) }}
      </span>

    </li>

    <div class="modes-model" v-if="modesmodel">

        <div class="modes-list">
            <div class="row" v-if="data!=null">

                <div class="col-md-2">
                    <div class="info-box">
                        <span class="info-box-icon " :class="{ 'bg-success': data.working>0, 'bg-danger': data.working<480 }"><i class="fa-solid fa-user-check"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Working</span>
                            <span class="info-box-number">{{ convertHM(data.working) }}</span>
                        </div>

                    </div>

                </div>
                <div class="col-md-2">
                    <div class="info-box">
                        <span class="info-box-icon " :class="{ 'bg-success': (data.morning<=15 && data.morning>0), 'bg-info': data.morning==0 , 'bg-danger': (data.morning>15 && data.morning>0) }"><i class="fa-solid fa-mug-saucer"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Morning Break</span>
                            <span class="info-box-number">{{ convertHM(data.morning) }}</span>
                        </div>

                    </div>

                </div>
                <div class="col-md-2">
                    <div class="info-box">
                        <span class="info-box-icon " :class="{ 'bg-success': (data.lunch<=30 && data.lunch>0), 'bg-info': data.lunch==0 , 'bg-danger': (data.lunch>30 && data.lunch>0) }"><i class="fa-solid fa-utensils"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Lunch Break</span>
                            <span class="info-box-number">{{ convertHM(data.lunch) }}</span>
                        </div>

                    </div>

                </div>
                <div class="col-md-2">
                    <div class="info-box">
                        <span class="info-box-icon " :class="{ 'bg-success': (data.evening<15 && data.evening>0), 'bg-info': data.evening==0 , 'bg-danger': (data.evening>15 && data.morning>0) }"><i class="fa-solid fa-mug-saucer"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Evening Break</span>
                            <span class="info-box-number">{{ convertHM(data.evening) }}</span>
                        </div>

                    </div>

                </div>
                <div class="col-md-2">
                    <div class="info-box">
                        <span class="info-box-icon " :class="{ 'bg-success': (data.meeting>0), 'bg-info': data.meeting==0 }"><i class="fa-solid fa-people-group"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Meeting</span>
                            <span class="info-box-number">{{ convertHM(data.meeting) }}</span>
                        </div>

                    </div>

                </div>
            </div>
            <div class="row" v-if="currentmode!=null">
                <div class="col-md-12" v-if="currentmode.mode_type=='Working'">
                    <div class="not-working-box">
                        <div class="box-items" >

                            <h1 class="text-center">Take Break</h1>
                            <form ref="form" @submit.prevent="startbreak">
                                <div class="form-group">
                                    <label >Break Type:</label>
                                    <select class="form-control"  v-model="form.breaktype" required>
                                        <option>Morning Break</option>
                                        <option>Lunch Break</option>
                                        <option>Evening Break</option>
                                        <option>Meeting</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <button type="submit" class="btn btn-primary" :disabled="loading" >START</button>
                                    <button type="button" class="btn btn-danger ml-2" @click="modesmodel=false" >CANCEL</button>
                                </div>

                            </form>
                        </div>
                    </div>
                    <div class="end-of-day-box">
                        <form ref="form" method="post" action="/user/submitendofday">
                            <input type="hidden" name="_token" :value="csrf">
                            <div class="form-group" v-if="data.working<workinghours">
                                <label >Reason of Early End of Day:</label>
                                <textarea class="form-control"  name="message" required></textarea>
                            </div>
                            <div class="form-group">
                                <button type="submit" class="btn btn-primary" :disabled="loading" >END OF DAY</button>
                            </div>

                        </form>
                    </div>

                </div>
                <div class="col-md-12" v-else>
                       <div class="not-working-box">
                           <div class="box-items" v-if="currentmode.mode_type=='Morning Break'">
                               <span class="info-box-icon bg-info"><i class="fa-solid fa-mug-saucer"></i></span>
                               <h1 class="text-center">{{ currentmode.mode_type }}</h1>
                               <h3  :class="{ 'text-success': (data.morning<=maxtime), 'text-danger': (data.morning>maxtime)}">{{ convertHM(data.morning) }}</h3>
                                <form ref="form" @submit.prevent="stopbreak">
                                    <div class="form-group">
                                        <label >Reason:</label>
                                        <textarea class="form-control" v-if="data.morning>maxtime" v-model="form.message" required></textarea>
                                    </div>
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-primary" :disabled="loading" >STOP</button>
                                    </div>

                                </form>
                           </div>
                           <div class="box-items" v-if="currentmode.mode_type=='Lunch Break'">
                               <span class="info-box-icon bg-info"><i class="fa-solid fa-utensils"></i></span>
                               <h1 class="text-center">{{ currentmode.mode_type }}</h1>
                               <h3  :class="{ 'text-success': (data.lunch<=maxtime), 'text-danger': (data.lunch>maxtime)}">{{ convertHM(data.lunch) }}</h3>
                               <form ref="form" @submit.prevent="stopbreak">
                                   <div class="form-group" v-if="data.lunch>maxtime">
                                       <label >Reason:</label>
                                       <textarea class="form-control"  v-model="form.message" required></textarea>
                                   </div>
                                   <div class="form-group">
                                       <button type="submit" class="btn btn-primary" :disabled="loading" >STOP</button>
                                   </div>

                               </form>
                           </div>
                           <div class="box-items" v-if="currentmode.mode_type=='Evening Break'">
                               <span class="info-box-icon bg-info"><i class="fa-solid fa-mug-saucer"></i></span>
                               <h1 class="text-center">{{ currentmode.mode_type }}</h1>
                               <h3  :class="{ 'text-success': (data.evening<=maxtime), 'text-danger': (data.evening>maxtime)}">{{ convertHM(data.evening) }}</h3>
                               <form ref="form" @submit.prevent="stopbreak">
                                   <div class="form-group" v-if="data.evening>maxtime">
                                       <label >Reason:</label>
                                       <textarea class="form-control"  v-model="form.message" required></textarea>
                                   </div>
                                   <div class="form-group">
                                       <button type="submit" class="btn btn-primary" :disabled="loading" >STOP</button>
                                   </div>

                               </form>
                           </div>
                           <div class="box-items" v-if="currentmode.mode_type=='Meeting'">
                               <span class="info-box-icon bg-info"><i class="fa-solid fa-people-group"></i></span>
                               <h1 class="text-center">{{ currentmode.mode_type }}</h1>
                               <h3  :class="{ 'text-success': (data.meeting<=maxtime), 'text-danger': (data.meeting>maxtime)}">{{ convertHM(data.meeting) }}</h3>
                               <form ref="form" @submit.prevent="stopbreak">
                                   <div class="form-group" v-if="data.meeting>maxtime">
                                       <label >Reason:</label>
                                       <textarea class="form-control"  v-model="form.message" required></textarea>
                                   </div>
                                   <div class="form-group">
                                       <button type="submit" class="btn btn-primary" :disabled="loading" >STOP</button>
                                   </div>

                               </form>
                           </div>
                       </div>




                </div>

            </div>

        </div>

    </div>


</template>

<script>
import moment from 'moment';
import { notify } from "@kyvg/vue3-notification";
export default {
    name: "AuxBox",
    props:['csrf'],
    components: {

    },
    data() {
        return {
            currentmode:null,
            data:null,
            modes:null,
            modesmodel:false,
            maxtime:0,
            workinghours:0,
            form: {
                message: '',
                breaktype:''
            }
        }
    },
    mounted() {
        this.getdata();
        this.interval = setInterval(this.incrementTime, 60000);

    },
    methods: {
        convertHM(value) {
            const min = parseInt(value, 10); // convert value to number if it's string
            let hours   = Math.floor(min / 60); // get hours
            let minutes = Math.floor((min - (hours * 60))); // get minutes

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            return hours+':'+minutes;

        },
        incrementTime() {
            if(this.currentmode.mode_type=="Working"){
                this.data.working = parseInt(this.data.working) + 1;
            }
            else if(this.currentmode.mode_type=="Morning Break"){
                this.data.morning = parseInt(this.data.morning) + 1;
            }
            else if(this.currentmode.mode_type=="Lunch Break"){
                this.data.lunch = parseInt(this.data.lunch) + 1;
            }
            else if(this.currentmode.mode_type=="Evening Break"){
                this.data.evening = parseInt(this.data.evening) + 1;
            }
            else if(this.currentmode.mode_type=="Meeting"){
                this.data.meeting = parseInt(this.data.meeting) + 1;
            }

        },
        dateTime(value) {
            return moment(value).format('DD MMM YY LT');
        },
        getdata() {
            let currentObj = this;
            this.loading = true;
            currentObj.modesmodel=false;
            axios.get('/user/getcurrentmode').then(function (response) {
                currentObj.currentmode = response.data.currentmode;
                currentObj.data = response.data.data;
                currentObj.modes = response.data.modes;
                currentObj.maxtime = response.data.maxtime;
                currentObj.workinghours = response.data.workinghours;
                currentObj.loading = false;

                if(currentObj.currentmode.mode_type!="Working"){
                    currentObj.modesmodel=true;
                }

            })
                .catch(function (error) {
                    currentObj.loading = false;
                });
        },
        stopbreak(e){
            e.preventDefault();
            let currentObj = this;
            this.loading = true;
            axios.post('/user/stopbreak', this.form).then(function (response) {

                currentObj.loading = false;
                currentObj.getdata();


            })
                .catch(function (error) {
                    currentObj.loading = false;
                });
        },
        startbreak(e){
            e.preventDefault();
            let currentObj = this;
            this.loading = true;
            axios.post('/user/startbreak', this.form).then(function (response) {

                currentObj.loading = false;
                currentObj.getdata();


            })
                .catch(function (error) {
                    currentObj.loading = false;
                });
        }



    }
}
</script>

<style scoped>

</style>
